<!--
 * @Description: 用户持有银行卡信息操作组件，增卡 由index.js 配置引入
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-04-24 14:46:45
 * @LastEditors: luoshoufeng@szkingdom.com
-->
<template>
    <div>
        <comp-title-dc back-url-name="info">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/info' }">个人中心</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/info' }">信息中心</el-breadcrumb-item>
                <el-breadcrumb-item>新增银行卡</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div :class="'bizcomp-add-bank bizcomp ' + className">
            <div class="add-bank-header-title">新增银行卡</div>
            <bank-operation />
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import bankOperation from "@/components/form/bankOperationDc";
export default {
    name: "AddBank",
    components: {
        bankOperation
    },
    mixins: [mixin],
    data() {
        return {};
    }
};
</script>
<style lang="scss" scoped>
.bizcomp-add-bank {
    .add-bank-header-title {
        width: 1160px;
        padding: 17px 0 21px 0;
        margin-left: 20px;
        border-bottom: 1px solid #f1f1f1;
        font-size: 20px;
        font-weight: 500;
        color: #333333;
    }
}
</style>
